import styles from '../../assets/styles/LandingPage/Footer.module.scss';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import React from 'react';

import {
	FaFacebookSquare,
	FaInstagram,
	FaTwitterSquare,
	FaLinkedin,
} from 'react-icons/fa';
import Logo from '../../assets/img/Mima-light-logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
	const navigate = useNavigate();
	const switchToLogin = () => {
		navigate(constant.Routes.Login);
	};

	return (
		<footer className={styles.footer}>
			<div className={styles.footer_a}>
				<div className={styles.footer__go}>
					<div className={styles.footer__pcl}>
						<div className={styles.pcl}>
							<div className={styles.pcl__header}>Products</div>
							<ul className={styles.pcl__ul}>
								<li className={styles.pcl__list} onClick={switchToLogin}>
									<a href="#" className={styles.pcl__item}>
										Business Insights
									</a>
								</li>
								<li className={styles.pcl__list} onClick={switchToLogin}>
									<a href="#" className={styles.pcl__item}>
										Invoice & Receipt
									</a>
								</li>
								<li className={styles.pcl__list}>
									<a
										href="#"
										className={styles.pcl__item}
										onClick={switchToLogin}>
										Payroll Management
									</a>
								</li>
								<li className={styles.pcl__list}>
									<a
										href="#"
										className={styles.pcl__item}
										onClick={switchToLogin}>
										Transaction Monitoring
									</a>
								</li>
								<li className={styles.pcl__list}>
									<a
										href="#"
										className={styles.pcl__item}
										onClick={switchToLogin}>
										Customers Engagement
									</a>
								</li>
								<li className={styles.pcl__list}>
									<a
										href="#"
										className={styles.pcl__item}
										onClick={switchToLogin}>
										Document Management
									</a>
								</li>
							</ul>
						</div>

						<div className={styles.pcl}>
							<div className={styles.pcl__header}>Company</div>
							<ul className={styles.pcl__ul}>
								<li className={styles.pcl__list}>
									<Link to={constant.Routes.About} className={styles.pcl__item}>
										About
									</Link>
								</li>
								<li className={styles.pcl__list}>
									<Link to={constant.Routes.Faqs} className={styles.pcl__item}>
										FAQs
									</Link>
								</li>
								{/* <li className={styles.pcl__list}>
									<a href="#" className={styles.pcl__item}>
										Blog
									</a>
								</li> */}
							</ul>
						</div>

						<div className={styles.pcl}>
							<div className={styles.pcl__header}>Legal</div>
							<ul className={styles.pcl__ul}>
								<li className={styles.pcl__list}>
									<Link to={constant.Routes.Terms} className={styles.pcl__item}>
										Terms
									</Link>
								</li>
								<li className={styles.pcl__list}>
									<Link
										to={constant.Routes.Privacy}
										className={styles.pcl__item}>
										Privacy
									</Link>
								</li>
							</ul>
						</div>
					</div>
					<p className={styles.footer__statement}>
						Mima is your all in one solution for managing your business. From
						sending invoices and receipts to setting up personal alerts, keeping
						track of income and expenses, analyzing performance, tracking taxes,
						paying employees and managing all the tasks that go along with
						running a business. There's so much to Mima and we're just getting
						started.
					</p>
				</div>
				<div className={styles.footer__contact}>
					<div className={styles.logSoc}>
						<div className={styles.logo}>
							<img src={Logo} className={styles.logo__main} alt="Mima logo" />
						</div>
						<div className={styles.footer__socials}>
							<a
								href="https://web.facebook.com/mimabusinessinc"
								target="_blank"
								rel="noreferrer">
								<FaFacebookSquare />
							</a>
							<a
								href="https://www.instagram.com/mimabusiness_hq/"
								target="_blank"
								rel="noreferrer">
								<FaInstagram />
							</a>
							<a
								href="https://twitter.com/MimaBusiness_Hq"
								target="_blank"
								rel="noreferrer">
								<FaTwitterSquare />
							</a>
							<a
								href="https://www.linkedin.com/company/trymima/"
								target="_blank"
								rel="noreferrer">
								<FaLinkedin />
							</a>
						</div>
					</div>

					<div className={styles.contact}>hello@trymima.com</div>
				</div>
			</div>

			<div className={styles.footer__copyright}>
				<p>&copy; 2023, Powered By SoftBlue Nigeria Limited</p>
			</div>
		</footer>
	);
};

export default Footer;
